import { Z_INDEX } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import { Notifications } from '@mantine/notifications';

let hostNode: HTMLDivElement | undefined;

const getToastHostNode = () => {
	if (!hostNode) {
		hostNode = document.createElement('div');
		hostNode.setAttribute('data-toast-host', 'true');
		document.body.appendChild(hostNode);
	}
	return hostNode;
};

export const ToastV2Host = () => (
	<Notifications
		position="bottom-left"
		zIndex={Z_INDEX.NOTIFICATION}
		portalProps={{ target: getToastHostNode() }}
	/>
);
